import React from 'react';
import { format } from 'sql-formatter';

import { CHART_SQL } from '../../../../tests/testids';

import './ChartSql.css';

interface ChartSqlProps {
  query: string;
}

export default function ChartSql({ query }: ChartSqlProps) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const formattedQuery = format(query);

  return (
    <div data-testid={CHART_SQL} className='Ispm-ChartSql'>
      <pre className='Ispm-ChartPanel-content'>
        <code>{formattedQuery}</code>
      </pre>
    </div>
  );
}
